const LOAD_TRIES: number = 5
const DELAY_BEFORE_TRY: number = 1000

export const useGlobalCallbacks = (): void => {
  if (import.meta.server) {
    return
  }

  const router = useRouter()

  const loadTwitter = (): void => {
    try {
      // @ts-expect-error Twitter widgets are not typed
      window.twttr?.widgets.load()
    }
    catch (ex: unknown) {
      console.error(ex)
    }
  }

  const loadInstagram = (): void => {
    try {
      // @ts-expect-error Instagram embeds are not typed
      window.instgrm?.Embeds.process()
    }
    catch (ex: unknown) {
      console.error(ex)
    }
  }

  onMounted(() => {
    loadTwitter()
    loadInstagram()
  })

  router.afterEach(() => {
    let loadTimes: number = 0

    const loadInterval = setInterval(() => {
      loadTwitter()
      loadInstagram()

      if (loadTimes >= LOAD_TRIES) {
        clearInterval(loadInterval)
      }

      loadTimes++
    }, DELAY_BEFORE_TRY)
  })
}
